import { render, staticRenderFns } from "./CustomerReportAutomation.vue?vue&type=template&id=745853b0&"
import script from "./CustomerReportAutomation.vue?vue&type=script&lang=js&"
export * from "./CustomerReportAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports